import React from "react";
import FuelByPersonReport from "../components/FuelByPersonReport";

export default function RapoarteCombustibil() {
  return (
    <div data-testid="page-rapoarte-combustibil">
      <div className="mb-6">
        <h1 className="font-display text-3xl font-extrabold">📊 Rapoarte combustibil</h1>
        <p className="text-sm text-zinc-500 mt-1">Total litri alimentați per șofer pe toată flota — interval lunar sau custom.</p>
      </div>
      <FuelByPersonReport hideTitle/>
    </div>
  );
}
